/// <amd-module name="Feed/Search/SearchProvider" />
import { ObservableValue } from "VSS/Core/Observable";
import { Services, VssService } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { ISearchProvider, ISearchQuery, ISearchResult, ISearchStatus } from "VSS/Platform/Search";


const InfiniteScrollFeatureFlag: string = "WebAccess.Search.Package.InfiniteScroll";

class FeedSearchProvider extends VssService implements ISearchProvider {
    public execute(searchQuery: ISearchQuery): ISearchStatus {
        return { searchQuery: searchQuery, searchResult: new ObservableValue<ISearchResult | undefined>(undefined) };
    }

    public getQuery(searchQuery: ISearchQuery): ISearchQuery {
        const packageSearchQuery: ISearchQuery = Object.assign(
            {
                // Note: the type mentioned here should be same as the 'supportedDocType' and 'displayedDocTypes'
                // in the contributions accordingly.
                type: "package"
            },
            searchQuery
        );

        if (isFeatureFlagEnabled(this.pageContext, InfiniteScrollFeatureFlag, false)) {
            packageSearchQuery.pageSize = 25;
        }

        return packageSearchQuery;
    }
}

Services.add("feed-search-provider", { serviceFactory: FeedSearchProvider });
